import Firebase from 'firebase'

export default{
    async initializeFirebase(config){
        const app = await Firebase.initializeApp(config)
        const db = app.firestore();
        return db
    },
    async destroyedApp(){
        // console.log(Firebase.apps)
        if(Firebase.apps.length > 0){
            await Firebase.app().delete()
        }
        return 
    }
}